import styled from 'styled-components';

export const RecentOrderCardCarouselContainer = styled.div``;
